/* eslint-disable */
require('./911-memorial-tours')
require('./add')
require('./arrow_left')
require('./arrow-round')
require('./arrow-upward')
require('./arrow')
require('./attention')
require('./behind-the-scenes-nyc')
require('./best_access-active')
require('./best_access')
require('./best_local_guides-active')
require('./best_local_guides')
require('./browse-tours')
require('./calendar_active')
require('./calendar')
require('./call-customer-support')
require('./cart_full')
require('./cart')
require('./checkmark_circle')
require('./checkmark_circled')
require('./checkmark')
require('./circle-close')
require('./clock')
require('./close-circle')
require('./close')
require('./collapse')
require('./colosseum-tours')
require('./colosseum')
require('./contact_information')
require('./copy')
require('./customer-login')
require('./cvv')
require('./david--duomo-tours')
require('./day-trips-from-rome')
require('./email')
require('./empty-star')
require('./exclusive')
require('./expand')
require('./facebook')
require('./faq-new')
require('./faq')
require('./filters')
require('./full-star')
require('./google-plus')
require('./guaranteed_departures-active')
require('./guaranteed_departures')
require('./guides')
require('./half-star')
require('./hamburger')
require('./highlights')
require('./instagram')
require('./live_chat')
require('./logo_badges')
require('./logo_small_footer')
require('./logo_small')
require('./logo-fleur')
require('./logo')
require('./long-arrow')
require('./louvre-tours')
require('./lys-flower-white')
require('./max')
require('./met-museum-tours')
require('./most_popular')
require('./most-popular-destinations')
require('./most-popular-florence-tours')
require('./most-popular-milan-tours')
require('./most-popular-new-york-tours')
require('./most-popular-paris-tours')
require('./most-popular-pompeii-tours')
require('./most-popular-rome-tours')
require('./most-popular-tours')
require('./most-popular-venice-tours')
require('./most-popular')
require('./new')
require('./notes-for-visiting')
require('./paris-catacombs-tours')
require('./partner_tours')
require('./payment_information')
require('./pinterest')
require('./planning')
require('./play')
require('./point-icon1')
require('./point-icon2')
require('./point-icon3')
require('./problems-while-traveling')
require('./promotions')
require('./question-mark')
require('./quote_big')
require('./quote_small')
require('./remove_tour')
require('./reviews')
require('./rome-catacombs')
require('./rome-food-tours')
require('./sale')
require('./sell_out')
require('./sign_up')
require('./similar-tours')
require('./small_groups-active')
require('./small_groups')
require('./something-different')
require('./sort-arrows')
require('./st-marks-basilica--doges-palace-tours')
require('./staff_pick')
require('./staff-picks')
require('./star_active')
require('./star_top_active')
require('./star_top_inactive')
require('./star_transparent')
require('./star-half')
require('./star')
require('./statue-of-liberty-tours')
require('./subtract')
require('./sustainable')
require('./tag')
require('./the-perfect-guide-everytime')
require('./tour_guides')
require('./twitter')
require('./uffizi-gallery-tours')
require('./upcoming-tours')
require('./vatican-tours')
require('./verified-reviews')
require('./walk')
require('./whatsapp')
